import React, { useEffect } from "react";
import "../style/success.scss";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import SuccessIcon from "../icon/SuccessIcon";
import CloseIcon from "../icon/CloseIcon";
import queryString from "query-string";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { routeToPage } from "../util/RouteToPage";
import PagePath from "../util/RoutePagePath";

const Success = () => {
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <HeaderBar />
      <div className="pay-content">
        <div className="box">
          <CloseIcon
            size={20}
            className="close"
            onClick={() => routeToPage(navigate, PagePath.HOME_PAGE)}
          />
          <SuccessIcon size={30} color="green" />
          <p>Success</p>
          <div className="view">OK</div>
        </div>
      </div>
      <FooterBar />
    </React.Fragment>
  );
};

export default Success;
